
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.032 17.297l.32-.384-.32.384zM2.244 11.61l-.322.383.322-.383zM9.037 1.314l-.32-.383.32.383zm.012.484h13.117v-1H9.05v1zM2.565 7.386l6.793-5.689-.642-.766L1.923 6.62l.642.766zm6.788 9.527l-6.788-5.685-.643.766 6.789 5.686.642-.767zm12.813-.129H9.05v1h13.116v-1zm2.506-12.48v9.975h1V4.304h-1zm-2.506 13.48a3.505 3.505 0 003.506-3.505h-1a2.505 2.505 0 01-2.506 2.505v1zm-12.623-.493c0 .273-.22.493-.493.493v-1a.507.507 0 00-.507.507h1zm-.832.389c.33.276.832.042.832-.389h-1c0-.418.489-.646.81-.378l-.642.767zM1.923 6.62a3.505 3.505 0 000 5.374l.642-.766a2.505 2.505 0 010-3.842l-.642-.766zM8.54 1.307c0-.145.065-.283.176-.376l.642.766a.509.509 0 00.182-.39h-1zm13.626.491a2.505 2.505 0 012.506 2.506h1A3.505 3.505 0 0022.166.798v1zM9.05.798a.509.509 0 00-.509.51h1c0 .27-.22.49-.49.49v-1zM18.614 6.782a.513.513 0 00-.727-.725l-2.513 2.516-2.514-2.516a.513.513 0 10-.726.725L14.648 9.3l-2.514 2.518a.513.513 0 00.726.725l2.514-2.516 2.513 2.516a.513.513 0 00.727-.725l-2.515-2.518 2.515-2.517z","fill":"#000C1F"}})])
          )
        }
      }
    